import { render, staticRenderFns } from "./ConfirmationSearchProductsPopup.vue?vue&type=template&id=358ca15d&"
import script from "./ConfirmationSearchProductsPopup.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSearchProductsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports